<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Terms" :submit="submit"
    :status="status" :canCancel="true" :canSubmit="false" :urlSendNotification="url_send_notification"
    :canUpdateDelete="false" :breadcrumbs="[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/spot_helps'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: 'Detalle',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters v-if="data.spot_id && data.spot_id.address">
            <v-col>
              <ValidationProvider ref="spot_id" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Lugars</div>
                <v-text-field :error-messages="errors" v-model="data.spot_id.address" readonly label="Lugars" solo
                  hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="rent_order_id" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Email</div>
                <v-text-field :error-messages="errors" readonly v-model="data.user_id.email" label="Email" solo
                  hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="help_option_id" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Opciones de Ayuda</div>
                <v-select :error-messages="errors" v-model="data.help_option_id" readonly :items="help_options"
                  item-text="title" item-value="id" label="Opciones de Ayuda" solo hide-details="auto"
                  class="input-base" append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="description" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Comment</div>
                <v-textarea readonly :error-messages="errors" v-model="data.comment" solo placeholder="Comment"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Imagen</div>
                <Upload :disabled="true" :error-messages="errors" accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen" prepend-icon="fas fa-camera" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></Upload>
                <v-img :src="picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  created() {
    this.loadCreated();
    /* this.getAllSpots();
    this.getAllRentOrder();
    this.getAllHelpOptions({show_all: 'enable'}); */
  },
  data() {
    return {
      storeName: "Spot_helps",
      title: "Reporte de Ayuda",
      filteredAttributes: ["picture"],
      picture: "",
      url_send_notification: "",
      data: {
        spot_id: {
          id: "",
          address: ""
        },
        rent_order_id: null,
        help_option_id: null,
        comment: null,
        picture: null,
        user_id: ''
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Terms.status,
      spots: (state) => state.Spots.list,
      rent_orders: (state) => state.Rent_orders.list,
      help_options: (state) => state.Help_options.list,
    }),
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      async handler(newId, oldId) {
        if (newId && newId !== oldId) {
          Object.assign(this.$data, this.$options.data.call(this))
          this.loadCreatedGlobal()
          this.loadCreated()
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getAllSpots: "Spots/getListAll",
      getAllRentOrder: "Rent_orders/getListAll",
      getAllHelpOptions: "Help_options/getListAll",
    }),
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
    onCreate(data) {
      if (data.user_id) {
        this.url_send_notification = `/admin/spot_helps/${data.id}/send_message`
      }
    },
    loadCreated() {
      this.getAllSpots();
      this.getAllRentOrder();
      this.getAllHelpOptions({ show_all: 'enable' });
    }
  },
};
</script>
